import { render, staticRenderFns } from "./SegregationTableEditor.vue?vue&type=template&id=0cb58508&scoped=true"
import script from "./SegregationTableEditor.vue?vue&type=script&lang=ts"
export * from "./SegregationTableEditor.vue?vue&type=script&lang=ts"
import style0 from "./SegregationTableEditor.vue?vue&type=style&index=0&id=0cb58508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb58508",
  null
  
)

export default component.exports